import { RootState } from '../store'

const getFilters = (state: RootState) => state.grants.allGrants.filters
const getSelectedAgencies = (state: RootState) => state.grants.allGrants.filters.agencies
const getSelectedPhases = (state: RootState) => state.grants.allGrants.filters.phases
const getSelectedStatuses = (state: RootState) => state.grants.allGrants.filters.statuses
const getStartDate = (state: RootState) => state.grants.allGrants.filters.dates.startDate
const getEndDate = (state: RootState) => state.grants.allGrants.filters.dates.endDate

export const GrantsSelectors = {
  getFilters,
  getSelectedAgencies,
  getSelectedPhases,
  getSelectedStatuses,
  getStartDate,
  getEndDate,
}